import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/three-dots-fff.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "bg-loading flex items-center justify-center w-full absolute top-0 left-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "caricando..."
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_notifications = _resolveComponent("notifications")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_router_view),
    _createVNode(_component_notifications, {
      group: "su",
      position: "top right",
      duration: "2",
      width: "360px",
      classes: "notifica temporanea"
    })
  ], 64))
}